module.exports = __webpack_public_path__ + "img/active-menu.4691991e.svg";